export default "__VITE_ASSET__B470_tn3__"